import { FranchiseActionTypes } from './constants';

export const getFranchises = () => ({
    type: FranchiseActionTypes.GET_FRANCHISES,
    payload: {},
});

export const getFranchisesSuccess = (franchises: any[]) => ({
    type: FranchiseActionTypes.GET_FRANCHISES_SUCCESS,
    payload: franchises,
});

export const getFranchisesError = (error: string) => ({
    type: FranchiseActionTypes.GET_FRANCHISES_ERROR,
    payload: error,
});

export const setCurrentFranchise = (franchiseId: string | null) => ({
    type: FranchiseActionTypes.SET_CURRENT_FRANCHISE,
    payload: franchiseId,
});
